import React from 'react';
import ContactForm from '../components/ContactForm';
import { MapPinIcon, MailIcon, LinkedinIcon } from 'lucide-react';
const Contact = () => {
  const handleEmailContact = () => {
    window.open('mailto:bhavinisapra4@gmail.com?subject=Reaching%20out%20from%20your%20portfolio', '_blank');
  };
  return <div className="bg-gray-900 text-white" data-id="element-343">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-344">
        <div className="text-center" data-id="element-345">
          <h1 className="text-4xl font-bold text-white sm:text-5xl" data-id="element-346">
            Let's Connect
          </h1>
          <p className="mt-6 text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-347">
            I love connecting with like-minded product professionals and
            discussing new opportunities. Whether you have a question, want to
            collaborate, or are interested in bringing me on board, I'd be
            delighted to hear from you.
          </p>
        </div>
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16" data-id="element-348">
          {/* Contact information */}
          <div data-id="element-349">
            <h2 className="text-2xl font-bold text-white" data-id="element-350">
              Contact Information
            </h2>
            <p className="mt-4 text-gray-300" data-id="element-351">
              Feel free to reach out through any of these channels. I'll get
              back to you as soon as possible.
            </p>
            <div className="mt-8 space-y-6" data-id="element-352">
              <div className="flex" data-id="element-353">
                <div className="flex-shrink-0" data-id="element-354">
                  <MapPinIcon className="h-6 w-6 text-indigo-400" data-id="element-355" />
                </div>
                <div className="ml-3 text-gray-300" data-id="element-356">
                  <p data-id="element-357">Kuala Lumpur, Malaysia</p>
                </div>
              </div>
              <div className="flex" data-id="element-358">
                <div className="flex-shrink-0" data-id="element-359">
                  <MailIcon className="h-6 w-6 text-indigo-400" data-id="element-360" />
                </div>
                <div className="ml-3 text-gray-300" data-id="element-361">
                  <button onClick={handleEmailContact} className="text-indigo-400 hover:text-indigo-300" data-id="element-362">
                    bhavinisapra4@gmail.com
                  </button>
                </div>
              </div>
              <div className="flex" data-id="element-363">
                <div className="flex-shrink-0" data-id="element-364">
                  <LinkedinIcon className="h-6 w-6 text-indigo-400" data-id="element-365" />
                </div>
                <div className="ml-3 text-gray-300" data-id="element-366">
                  <a href="https://www.linkedin.com/in/bhavinisapra/" target="_blank" rel="noopener noreferrer" className="text-indigo-400 hover:text-indigo-300" data-id="element-367">
                    LinkedIn Profile
                  </a>
                </div>
              </div>
            </div>
            <div className="mt-12 bg-gray-800 p-6 rounded-lg border border-gray-700" data-id="element-368">
              <h3 className="text-lg font-medium text-white" data-id="element-369">
                Looking for a Product Leader?
              </h3>
              <p className="mt-2 text-gray-300" data-id="element-370">
                I'm currently exploring Product Manager opportunities at FAANG
                companies and other innovative tech organizations. My expertise
                includes:
              </p>
              <ul className="mt-4 space-y-2 text-gray-300" data-id="element-371">
                <li className="flex items-center" data-id="element-372">
                  <div className="h-2 w-2 bg-indigo-500 rounded-full mr-2" data-id="element-373"></div>
                  <span data-id="element-374">Strategic product planning and roadmapping</span>
                </li>
                <li className="flex items-center" data-id="element-375">
                  <div className="h-2 w-2 bg-indigo-500 rounded-full mr-2" data-id="element-376"></div>
                  <span data-id="element-377">Cross-functional team leadership</span>
                </li>
                <li className="flex items-center" data-id="element-378">
                  <div className="h-2 w-2 bg-indigo-500 rounded-full mr-2" data-id="element-379"></div>
                  <span data-id="element-380">Data-driven decision making</span>
                </li>
                <li className="flex items-center" data-id="element-381">
                  <div className="h-2 w-2 bg-indigo-500 rounded-full mr-2" data-id="element-382"></div>
                  <span data-id="element-383">User-centered product development</span>
                </li>
              </ul>
            </div>
          </div>
          {/* Contact form */}
          <div className="bg-gray-800 rounded-lg p-8 border border-gray-700" data-id="element-384">
            <h2 className="text-2xl font-bold text-white" data-id="element-385">Send Me a Message</h2>
            <div className="mt-6" data-id="element-386">
              <ContactForm data-id="element-387" />
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Contact;